import {initMobileHeader} from '../components/header';

function initTransVideo() {
	let currentJsFrame = '.js-iframe';
	let $nextPage = $(`[data-page=${$(document).data('current-page')}]`);

	if ($nextPage.data('page') === 'home') {
		if (innerWidth > 1024) {
			currentJsFrame = '.js-iframe.for-desktop';
		} else {
			currentJsFrame = '.js-iframe.for-mobile';
		}
	}

	$nextPage.find(`${currentJsFrame}`).each((index, element) => {
		let src = $(element).data('src');

		$(element).append(`<iframe src="${src}"></iframe>`);
	});
}

export function showPage(page) {
	return new Promise((resolve) => {
		let $prevPage = $(`[data-page=${$(document.documentElement).attr('data-current-page')}]`);
		let $nextPage = $(`[data-page=${page}]`);
		let prevPageData = $(document.documentElement).attr('data-current-page');

		$(document).data('current-page', page);
		$(document).attr('data-current-page', page);

		if ($prevPage.data('page') !== $nextPage.data('page')) {
			new TimelineMax({
				onStart() {
					window.scrollTo(0, 0);

					if (prevPageData !== undefined) {
						$('.circle-item, .small-circle-item').addClass('not-opacity');
					}
				},
				onComplete() {
					if (page !== 'home') {
						initMobileHeader($nextPage);
					}
				},
			})
				.to($prevPage, 0.3, {
					opacity: 0,
					onComplete() {
						TweenMax.set($prevPage, {clearProps: 'all'});
						$prevPage.trigger('page:hide');
						$nextPage.trigger('page:show');

						$('.js-iframe').empty();

						if (page === 'home' || page === 'teaser') {
							initTransVideo();
						}
					},
				})
				.fromTo($nextPage, 0.3, {
					opacity: 0,
				}, {
					onStart() {

					},
					opacity: 1,
					clearProps: 'all',
				});
		}

		$(document.documentElement).data('current-page', page);
		$(document.documentElement).attr('data-current-page', page);

		resolve();
	});
}

export function showHome() {
	showPage('home');
}

export function showArticle(id) {
	showPage(`article-${id}`);
}
